import {
  JsonApiCurrentUser,
  ProfileType,
} from '../../../../@types/jsonapi.d';
import { HeaderConfigItem } from '../@types/HeaderConfig.d';
import companyAdminConfig from '../config/companyAdmin/companyAdmin';
import mjgAdminConfig from '../config/mjgAdmin/mjgAdmin';
import moderatorConfig from '../config/moderator/moderator';
import professionalConfig from '../config/professional/professional';
import schoolCoachConfig from '../config/school-coach/school-coach';
import studentConfig from '../config/student/student';
import visitorConfig from '../config/visitor/visitor';
import { isDisplayCompanyAdminHeader } from './company-admin';
import { isDisplaySchoolCoachHeader } from './school-coach';
import { isDisplayMJGAdminHeader } from './mjg-admin';
import styles from '../Header.module.scss';

/**
 * Get the header config for currentUser
 * @param {Object} user
 * @return {{ main: Object[], connected: Object[] }}
 */
interface HeaderConfigMixte {
  main: HeaderConfigItem[];
  connected?: HeaderConfigItem[];
}
export function getHeaderProfileConfiguration(
  user: JsonApiCurrentUser,
  route: string,
): HeaderConfigMixte {
  if (user) {
    if (isDisplayCompanyAdminHeader(route, user)) {
      return companyAdminConfig;
    }
    if (isDisplayMJGAdminHeader(route, user)) {
      return mjgAdminConfig;
    }
    switch (user.type) {
      case ProfileType.employee:
      case ProfileType.mentor:
        return professionalConfig;
      case ProfileType.student:
        return studentConfig;
      case ProfileType.moderator:
        return moderatorConfig;
      case ProfileType.schoolCoach:
        return schoolCoachConfig;
      default:
        return visitorConfig;
    }
  }
  return visitorConfig;
}

export function getHeaderVariant(
  user: JsonApiCurrentUser,
  route: string,
) {
  if (
    isDisplayCompanyAdminHeader(route, user)
    || isDisplaySchoolCoachHeader(route, user)
    || isDisplayMJGAdminHeader(route, user)
  ) {
    return styles.blueVariant;
  }
  return undefined;
}

export function getHeaderLogoVariant(
  user: JsonApiCurrentUser,
  route: string,
) {
  if (
    isDisplayCompanyAdminHeader(route, user)
    || isDisplayMJGAdminHeader(route, user)
    || isDisplaySchoolCoachHeader(route, user)
  ) {
    return 'white';
  }
  return undefined;
}
